import React from "react";
import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

type Props = AriaButtonProps &
  Pick<
    ButtonProps,
    | "leftIcon"
    | "rightIcon"
    | "size"
    | "fullWidth"
    | "fill"
    | "hoverFill"
    | "isLoading"
    | "testID"
    | "border"
    | "testID"
    | "iconSize"
    | "iconColor"
    | "iconType"
  > & {
    slot?: string;
  };

export function GhostButton({ hoverFill, slot, ...props }: Props) {
  const { testID = "ghost-button" } = props;

  return (
    <_Button
      color="text-base"
      focusStyle="focus-action"
      hoverFill={hoverFill ? hoverFill : "background-ghost-hover"}
      iconColor="icon-base"
      loaderColor="icon-success"
      testID={testID}
      slot={slot}
      {...props}
    />
  );
}
